import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'IrrigationGroup';

export type IrrigationGroupProps = {
  // ForecastAreaApplicationRate not needed?
  site?: string;
};

export class IrrigationGroup extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }
  // ForecastAreaApplicationRate not needed?
  site?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      ForecastAreaApplicationRate: {
        type: 'RelatedType',
        editable: false,
        label: 'Forecast Area Application Rate',
        name: 'ForecastAreaApplicationRate',
        description: 'Total forecasted application rate (mm/m2) for the area',
        objectTypeId: 'Irrigation_Readings|P' as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: 'Irrigation_Group_has_ForecastAreaApplicationRate_Irrigation_Readings|P',
      },
      site: { type: 'String', editable: true, label: 'Site', name: 'site', description: 'Associated site (Fields)' },
    };
  };
}
